import React from "react";
import { FaStar, FaBuilding, FaGraduationCap, FaCode, FaCog } from "react-icons/fa";
import whyChooseUsImage from "../../assets/WhyChoooseWe.png";

const WhyChooseUs = () => {
  return (
    <div className="py-8 px-2 sm:px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-xl sm:text-2xl md:text-2xl lg:text-3xl font-bold text-gray-900 mb-2 sm:mb-3">
            Why Choose Insytix?
            <div className="w-16 sm:w-24 h-1 bg-blue-600 mx-auto mt-2"></div>
          </h2>
          <p className="text-sm sm:text-base md:text-base text-gray-600 max-w-3xl mx-auto">
            With our own expert faculty, advanced labs, and strong industry practices, we provide students with everything they need to succeed.
          </p>
        </div>

        {/* Responsive content grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-start">
          {/* Image Section (goes above on mobile, right on desktop) */}
          <div className="order-1 lg:order-2 mb-6 lg:mb-0 flex items-center justify-center">
            <div className="w-full max-w-xs min-h-[200px] sm:min-h-[280px] md:min-h-[340px] bg-gray-200 rounded-lg flex items-center justify-center relative overflow-hidden mx-auto">
              <div className="absolute -top-4 right-2 w-16 h-16 sm:w-24 sm:h-24 md:w-32 md:h-32 bg-pink-200 rounded-full opacity-30"></div>
              <img
                src={whyChooseUsImage}
                alt="Why Choose Us"
                className="relative z-10 max-w-full max-h-[140px] sm:max-h-[220px] md:max-h-[300px] object-contain"
              />
            </div>
          </div>

          {/* Content Section (features) */}
          <div className="order-2 lg:order-1 space-y-4 sm:space-y-6 md:space-y-8">
            {/* Hands-on Project Learning */}
            <div className="flex items-start gap-3 sm:gap-5">
              <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-16 md:h-16 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                <FaCode className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-blue-600" />
              </div>
              <div>
                <h3 className="text-base sm:text-lg md:text-xl font-semibold text-gray-900 mb-1 sm:mb-2">
                  Hands-on Project Learning
                </h3>
                <p className="text-xs sm:text-sm md:text-base text-gray-600">
                  Build practical expertise through real-time projects designed around industry standards.
                </p>
              </div>
            </div>
            
            {/* Experienced In-House Instructors */}
            <div className="flex items-start gap-3 sm:gap-5">
              <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-16 md:h-16 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                <FaStar className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-blue-600" />
              </div>
              <div>
                <h3 className="text-base sm:text-lg md:text-xl font-semibold text-gray-900 mb-1 sm:mb-2">
                  Experienced In-House Instructors
                </h3>
                <p className="text-xs sm:text-sm md:text-base text-gray-600">
                  Train under our dedicated team of professionals who bring years of technical expertise and mentoring experience.
                </p>
              </div>
            </div>

            {/* Recognized Certifications */}
            <div className="flex items-start gap-3 sm:gap-5">
              <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-16 md:h-16 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                <FaBuilding className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-blue-600" />
              </div>
              <div>
                <h3 className="text-base sm:text-lg md:text-xl font-semibold text-gray-900 mb-1 sm:mb-2">
                  Recognized Certifications
                </h3>
                <p className="text-xs sm:text-sm md:text-base text-gray-600">
                  Earn trusted credentials from INSYTIX that validate your skills and strengthen your career profile.
                </p>
              </div>
            </div>

            {/* Continuous Improvement */}
            <div className="flex items-start gap-3 sm:gap-5">
              <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-16 md:h-16 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                <FaCog className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-blue-600" />
              </div>
              <div>
                <h3 className="text-base sm:text-lg md:text-xl font-semibold text-gray-900 mb-1 sm:mb-2">
                  Continuous Improvement
                </h3>
                <p className="text-xs sm:text-sm md:text-base text-gray-600">
                  Curriculum updated with latest technologies
                </p>
              </div>
            </div>

            {/* Career Opportunities Within INSYTIX */}
            <div className="flex items-start gap-3 sm:gap-5">
              <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-16 md:h-16 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                <FaGraduationCap className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-blue-600" />
              </div>
              <div>
                <h3 className="text-base sm:text-lg md:text-xl font-semibold text-gray-900 mb-1 sm:mb-2">
                  Career Opportunities Within INSYTIX
                </h3>
                <p className="text-xs sm:text-sm md:text-base text-gray-600">
                  Unlike traditional institutes, we offer the unique advantage of direct placement opportunities within our own company, for students who demonstrate exceptional performance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
